
import { Link } from "react-router-dom";


const subTitle = "Article d'actualités";
const title = "Informations, nouveautées et conseils d'experts";


const blogList = [
    {
        imgUrl: 'assets/images/blog/01.jpg',
        imgAlt: 'blog thumb rajibraj91 rajibraj',
        title: 'Les créatifs écossais recevront des affaires financées.',
        author: 'Emilie Steven',
        date: '23 Avril 2022',
        desc: 'Pluoresnts personnalisent le service client centré sur le caracolage et straelg ands asing straelg Interacvely coordinate performe.',
        btnText: 'Lire la suite',
        commentCount: '4',
    },
    {
        imgUrl: 'assets/images/blog/02.jpg',
        imgAlt: 'blog thumb rajibraj91 rajibraj',
        title: 'Les créatifs écossais recevront des affaires financées.',
        author: 'Gérard Firland',
        date: '23 Avril 2022',
        desc: 'Pluoresnts personnalisent le service client centré sur le caracolage et straelg ands asing straelg Interacvely coordinate performe.',
        btnText: 'Lire la suite',
        commentCount: '1',
    },
    {
        imgUrl: 'assets/images/blog/03.jpg',
        imgAlt: 'blog thumb rajibraj91 rajibraj',
        title: 'Les créatifs écossais recevront des affaires financées.',
        author: 'Begrass Tyson',
        date: '02 Mars 2022',
        desc: 'Pluoresnts personnalisent le service client centré sur le caracolage et straelg ands asing straelg Interacvely coordinate performe.',
        btnText: 'Lire la suite',
        commentCount: '6',
    },
]

const Blog = () => {
    return (
        <div className="blog-section padding-tb section-bg">
            <div className="container">
                <div className="section-header text-center">
                    <span className="subtitle">{subTitle}</span>
                    <h2 className="title">{title}</h2>
                </div>
                <div className="section-wrapper">
                    <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 justify-content-center g-4">
                        {blogList.map((val, i) => (
                            <div className="col" key={i}>
                                <div className="post-item">
                                    <div className="post-inner">
                                        <div className="post-thumb">
                                            <Link to="/blog-single"><img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} /></Link>
                                        </div>
                                        <div className="post-content">
                                            <Link to="/blog-single"><h4>{val.title}</h4></Link>
                                            <div className="meta-post">
                                                <ul className="lab-ul">
                                                    <li style={{fontFamily:  'AvenirNextReg'}}><i className="icofont-ui-user"></i>{val.author}</li>
                                                    <li style={{fontFamily:  'AvenirNextReg'}}><i className="icofont-calendar"></i>{val.date}</li>
                                                </ul>
                                            </div>
                                            <p style={{fontFamily:  'AvenirNextReg'}}>{val.desc}</p>
                                        </div>
                                        <div className="post-footer">
                                            <div className="pf-left">
                                                <Link to="/blog-single" className="lab-btn-text">{val.btnText} <i className="icofont-external-link"></i></Link>
                                            </div>
                                            <div className="pf-right">
                                                <i className="icofont-comment"></i>
                                                <span className="comment-count">{val.commentCount}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default Blog;